import cn from 'classnames';
import { createElement, forwardRef } from 'react';

import styles from './RichText.module.scss';

export type RichTextProps = {
  field: string | undefined;
  styleType?: 'p1' | 'p2' | 'p3' | 'sub-text' | 'none';
  tag?: keyof JSX.IntrinsicElements;
  className?: string;
};

const RichText = forwardRef<HTMLDivElement, RichTextProps>(function BaseHelpersRichText(
  props: RichTextProps,
  ref
): JSX.Element {
  const { styleType = 'p2', className, field, tag = 'div' } = props;

  const customClassName = className;

  const stylingClass = styleType && styleType !== 'none' && cn(styles.main, styles[styleType]);

  if (field) {
    return createElement(tag, {
      className: cn(stylingClass, customClassName),
      ref: ref,
      dangerouslySetInnerHTML: {
        __html: field,
      },
    });
  }
  return <></>;
});

export default RichText;
